import { Box } from '~/components/layout'
import { Link } from '~/components/link'
import { Logo } from '~/components/logo'
import { Heading, Meta, Text } from '~/components/typography'
import { routes } from '~/config/routes'
import { useMediaQuery } from '~/hooks/use-media-query'
import { colors } from '~/styles/colors'

import { Divider, Header, Main, Page, Side, Subheading } from './style'
import Head from 'next/head'
import GoogleIdentityHeadScript from '~/components/google-identity/google-identity-head-script'

type Props = {
  heading: string
  subheading: React.ReactNode
  children: React.ReactNode
  headerLink?: React.ReactNode
}

export const AuthLayout = ({
  heading,
  subheading,
  children,
  headerLink = null,
}: Props) => {
  const matches = useMediaQuery({ min: 1000 })

  return (
    <>
      <Head>
        <GoogleIdentityHeadScript />
      </Head>

      <Page>
        <Header>
          <Logo variant={matches ? 'light' : 'dark'} />
          {headerLink}
        </Header>
        <Side>
          <Heading
            level={2}
            marginBottom={26}
            style={{
              fontSize: '2.25rem',
              lineHeight: 1.4,
              color: colors.white,
            }}
          >
            The Next Step in Online Fundraising
          </Heading>
          <Text bold style={{ color: colors.white }}>
            Kindest brings modern marketing methods to the online fundraising
            world with simple and easy to use tools.
          </Text>
        </Side>

        <Main>
          <Box width={1} maxWidth={400}>
            <div className="text-center mb-6">
              <Link href={routes.bookDemo} external>
                <Meta as="a" regular color={colors.slateGray}>
                  New to Kindest? <b className="font-semibold"> Book a demo</b>
                </Meta>
              </Link>
            </div>
            <Heading level={2} textAlign="center">
              {heading}
            </Heading>
            <Subheading>{subheading}</Subheading>
            {children}
          </Box>
        </Main>
      </Page>
    </>
  )
}

AuthLayout.Divider = Divider
